if (!customElements.get('vayndo-product-gallery')) {
  customElements.define('vayndo-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.photos = [...this.querySelectorAll('[data-gallery-photo]')];
      this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')];
      this.zoomButton = this.querySelector('[data-gallery-zoom]');
      this.status = this.querySelector('[data-gallery-status]');
      this.dialog = this.querySelector('dialog');
      this.dialogImage = this.querySelector('[data-gallery-dialog-image]');
      this.index = 0;
      if (!this.photos.length || !this.zoomButton || !this.dialog || !this.dialogImage) return;
      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-gallery-thumbnail]');
        if (thumbnail) this.select(Number(thumbnail.dataset.galleryThumbnail));
        if (event.target.closest('[data-gallery-previous]')) this.select(this.index - 1);
        if (event.target.closest('[data-gallery-next]')) this.select(this.index + 1);
        if (event.target.closest('[data-gallery-zoom]')) this.open();
        if (event.target.closest('[data-gallery-close]') || event.target === this.dialog) this.dialog.close();
      }, options);
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.photos.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.select(index);
        if (event.target.closest('[data-gallery-thumbnail]')) this.thumbnails[this.index]?.focus();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('vayndo-gallery-open');
        this.zoomButton.focus({ preventScroll: true });
      }, options);
      this.select(0, false);
    }

    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.classList.remove('vayndo-gallery-open');
      }
    }

    select(index, announce = true) {
      if (!this.photos?.length || !Number.isFinite(index)) return;
      this.index = ((index % this.photos.length) + this.photos.length) % this.photos.length;
      this.photos.forEach((photo, i) => { photo.hidden = i !== this.index; });
      this.classList.toggle('vayndo-gallery--artwork', Boolean(this.photos[this.index].querySelector('[data-gallery-artwork]')));
      this.thumbnails.forEach((thumbnail, i) => thumbnail.setAttribute('aria-pressed', String(i === this.index)));
      this.zoomButton.setAttribute('aria-label', this.photos[this.index].dataset.openLabel);
      if (announce && this.status) this.status.textContent = this.photos[this.index].dataset.status;
      if (this.dialog.open) this.updateDialog();
    }

    updateDialog() {
      const selectedPhoto = this.photos?.[this.index];
      const selectedContent = selectedPhoto?.querySelector('[data-gallery-artwork]') || selectedPhoto?.querySelector('img');
      if (!selectedContent || !this.dialogImage) return;
      const content = selectedContent.cloneNode(true);
      const images = content.matches('img') ? [content] : [...content.querySelectorAll('img')];
      images.forEach((image) => {
        image.removeAttribute('loading');
        image.removeAttribute('fetchpriority');
        image.sizes = '100vw';
      });
      this.dialogImage.replaceChildren(content);
    }

    open() {
      if (!this.photos?.length || !this.dialog || this.dialog.open) return;
      this.updateDialog();
      this.dialog.showModal();
      document.documentElement.classList.add('vayndo-gallery-open');
    }
  });
}
